<template>
	<!-- 再审素材 -->
	<div style="background-color: #F5F5F5;margin-top:0.7rem;">
		<div class="newTrialMaterial comBox ">
			<div class="left">
				<leftTemplate1 :left_tabShow="'new_trial_material'"></leftTemplate1>
			</div>
			<div class="right">
				<div style="height: 0.08rem;"></div>
				<el-tabs v-model="activeName" class="demo-tabs" @tab-change="handleClick">
					<el-tab-pane :label="item.label" :name="item.name" v-for="item in activeList" :key="item">
						<div class="newTrialMaterial_box">

							<el-dropdown @command="dropdownClick">
								<span class="el-dropdown-link">
									{{ top_type == 'MUSIC' ? '音乐' : top_type == 'VIDEO' ? '视频' : top_type == 'IMAGE' ? '图片'
										: '全部素材/模板' }}
									<img style="width: 14px;height: 14px;" src="../../assets/img/dropselect2.png" />
								</span>
								<template #dropdown>
									<el-dropdown-menu>
										<el-dropdown-item command="">全部素材/模板</el-dropdown-item>
										<el-dropdown-item command="VIDEO">视频</el-dropdown-item>
										<el-dropdown-item command="MUSIC">音乐</el-dropdown-item>
										<el-dropdown-item command="IMAGE">图片</el-dropdown-item>
									</el-dropdown-menu>
								</template>
							</el-dropdown>
						</div>
						<div>
							<!-- style="height: 550px;" -->

							<div v-if="isTableLoading">
								<el-table v-if="data.length != 0" ref="multipleTableRef" :show-header="false" :data="data"
									style="width: 100%" height="450">

									<el-table-column property="name" label="商品信息">
										<template #default="scope">

											<div style="display: flex;">
												<div style="" class="table_img">
													<!-- :preview-src-list="[scope.row.showImage]" -->
													<el-image style="width: 100%; height:100%"
														:src="scope.row.showImage || scope.row.filePath" :zoom-rate="1.2"
														:initial-index="4" fit="cover">
														<template #error>
															<div class="image-slot" style="width: 100%; height:100%">
																<img style="width: 100%; height:100%"
																	src="../../assets/img/noImg.png" />
															</div>
														</template>
													</el-image>
												</div>
												<div class="table_information">
													<div
														style=" white-space: nowrap;overflow: hidden;text-overflow: ellipsis; color: #333333; ">
														{{ scope.row.title }}{{ scope.row.fileExt }}
													</div>
													<div style="color: #86909C; font-size: 0.14rem;;">
														{{ scope.row.updateTime }}提交审核
													</div>
													<div v-if="scope.row.status == '-1'"
														style="color: #F53F3F;font-size: 0.14rem;">
														审核未通过：{{ scope.row.auditMsg }}</div>
													<!-- <div v-if="scope.row.status == 0" style="color: #F53F3F;font-size: 0.14rem;">
														审核中：视频中含有文字，建议删除后在上传</div> -->

												</div>
											</div>


										</template>
									</el-table-column>
									<el-table-column label="操作" :width="item.satus == 2 ? '80' : '190'">
										<template #default="scope">
											<div style="display: flex;" v-if="item.satus != '0'">
												<div style="width: 100px; cursor: pointer;" class="topBtn"
													@click="handlePerfect(scope.row,)">
													修改信息</div>
												<div @click="handleDel(scope.$index, scope.row, 'del')"
													style="color: #FF2929;margin-left: 0.1rem;line-height: 0.43rem;cursor: pointer;">
													删除
												</div>
											</div>
											<div style="color: #C01A26;" v-else>
												审核中
											</div>

										</template>
									</el-table-column>
								</el-table>
								<!-- size-change page-size 改变时触发
								current-change current-page 改变时触发
								prev-click 用户点击上一页按钮改变当前页时触发
								next-click 用户点击下一页按钮改变当前页时触发
								pageNum 和 pageSize 分别是页数和每页显示大小 -->
								<el-pagination v-if="data.length != 0" v-model:current-page="page.pageNum"
									v-model:page-size="page.pageSize" @size-change="sizeChange"
									@current-change="currentChange" style="margin:0.4rem 0;" background
									layout="prev, pager, next" :total="page.total" />




							</div>

							<div style="height: 550px;" v-if="data.length == 0">
								<div style="width: 60%;margin: 0 auto;">
									<img style="width: 100%;margin: 0 auto;" src="../../assets/zt_404.png" />

								</div>

							</div>

						</div>
					</el-tab-pane>
				</el-tabs>




			</div>
		</div>
		<!-- 删除 -->
		<el-dialog title="" v-model="dialogDelVisible" align-center width="480px" :close-on-click-modal="false">


			<div style="width: 0.4rem;height: 0.4rem;margin: 0 auto">
				<img style="100%;height: 100%;" src="@/assets/img/tips／exclamation-circle-fill@2x.png" />
			</div>

			<div style="text-align: center;font-size: 0.16rem;margin: 0.16rem 0;">{{ title }}</div>
			<div style="display: flex;justify-content: center;">
				<div class="dataBtnClose" @click="dialogDelVisible = false">取消</div>
				<div class="dataBtnSubmit" @click="delSubmit">确认</div>
			</div>
		</el-dialog>

	</div>
</template>

<script lang="ts" setup>
import leftTemplate1 from '@/components/leftTemplate1.vue'
import {
	ref
} from 'vue'
import type {
	TabsPaneContext
} from 'element-plus'
import {
	ElMessage,
	ElTable
} from 'element-plus'
import {
	Axios
} from "../../assets/js/ls_com_axios.js";
import {
	serverUrls
} from "../../assets/js/ls_tgServerUrls.js";


let pageDef = ref({
	pageNum: 1,
	pageSize: 10,
	total: 0
})
//审核未审核状态
const active_value = ref(0);
if (localStorage.getItem("zssc")) {
	active_value.value = localStorage.getItem("zssc") == 'first' ? 0 : localStorage.getItem("zssc") == 'second' ? 1 : '-1'
} else {
	active_value.value = 0
}
const page = pageDef;
const activeName = ref('')
if (localStorage.getItem("zssc")) {
	activeName.value = localStorage.getItem("zssc")

} else {
	activeName.value = 'first'

}
// 类型
const top_type = ref('')
if (localStorage.getItem("zssc_type")) {
	top_type.value = localStorage.getItem("zssc_type")
} else {
	//  localStorage.setItem("zssc_type" , 0)
	// top_type.value = localStorage.getItem("zssc_type")

}
const activeList = ref([{
	label: '审核中',
	name: 'first',
	satus: '0',
},
{
	label: '未通过',
	name: 'third',
	satus: '-1',
}
])

const handleClick = (tab: TabsPaneContext, event: Event) => {
	localStorage.setItem("zssc", tab)
	isTableLoading.value = false;
	active_value.value = localStorage.getItem("zssc") == 'first' ? 0 : localStorage.getItem("zssc") == 'second' ? 1 : '-1';
	init();
}
// handleClick('first' ,  '')
// 表格
const allCheckbox = ref(false)

interface User {
	date: string
	name: string
	address: string
	katype: string
	pirce: string,
	number: number,
}

const multipleTableRef = ref<InstanceType<typeof ElTable>>()
const multipleSelection = ref<User[]>([])
const toggleSelection = (rows?: User[]) => {
	if (rows) {
		rows.forEach((row) => {
			multipleTableRef.value!.toggleRowSelection(row, undefined)
		})
	} else {
		multipleTableRef.value!.clearSelection()
	}
}
const handleSelectionChange = (val: User[]) => {
	multipleSelection.value = val
}
//列表请求
var data = []; // 创建一个空数组
let memberId = JSON.parse(localStorage.getItem('userList')).memberId;
const isTableLoading = ref(false);

const init = () => {
	console.log(top_type.value)
	console.log("===========================")

	let paramsA = {}
	if (top_type.value) {
		paramsA = {
			memberId: memberId,
			status: active_value.value || 0,
			materialType: top_type.value,
			pageNum: page.value.pageNum,
			pageSize: page.value.pageSize,
			orderByColumn: 'createTime',
			isAsc: 'desc'
		}
	} else {
		paramsA = {
			memberId: memberId,
			status: active_value.value || 0,
			pageNum: page.value.pageNum,
			pageSize: page.value.pageSize,
			orderByColumn: 'createTime',
			isAsc: 'desc'
		}
	}
	isTableLoading.value = false;
	Axios('get', '/fodder/manage/audit-list', paramsA, false, function (res) {
		if (res.data.rows.length != 0) {
			data = res.data.rows;
			page.value.total = res.data.total;
			setTimeout(() => {
				isTableLoading.value = true;
			}, 50)
		} else {
			setTimeout(() => {
				data = [];
				isTableLoading.value = true;
			}, 50)
		}


	})
	Axios('get', `/fodder/my-count/${memberId}`, {}, false, function (res) {
		console.log(res.data.rows)
	})

}
init();
// 删除、批量删除


let title = ref('');
let dialogDelVisible = ref(false);
let idArray = ref([]);
const handleDel = (index, row, type) => {
	title.value = type == 'del' ? '删除后则无法恢复，是否继续？' : '是否确认将所选全部在售素材？'
	if (type == 'del') {
		if (row.id) {
			idArray = [row.id]
			dialogDelVisible.value = true;
		} else {
			fileList.splice(index, 1);
		}
	} else {
		dialogDelVisible.value = true;
	}

}
const delSubmit = () => {
	Axios('delete', `/fodder/manage/remove/${idArray}`, {}, false, (res) => {
		if (res.data.code == 200) {
			dialogDelVisible.value = false;
			// 要删除的索引数组
			isTableLoading.value = false;
			init();

			ElMessage({
				message: '删除成功',
				type: 'success',
			})
		} else {
			ElMessage({
				message: '删除错误',
				type: 'error',
			})
		}

	})

}
//完善信息
import {
	useRouter
} from "vue-router";
const router = useRouter();
// handlePerfect
const handlePerfect = (row) => {

	// IMAGE, MUSIC, VIDEO
	if (row.materialType == 'VIDEO') {
		router.push({

			path: '/materiaPerfect',
			query: {
				id: row.id
			}

		},)
	} else if (row.materialType == 'MUSIC') {
		router.push({

			path: '/musicPerfect',
			query: {
				id: row.id
			}

		},)
	} else if (row.materialType == 'IMAGE') {
		router.push({

			path: '/picturePerfect',
			query: {
				id: row.id
			}

		},)
	}

}

//全部素材选择

const dropdownClick = (command: string | number | object) => {
	localStorage.setItem('zssc_type', command)
	top_type.value = localStorage.getItem('zssc_type');
	console.log(top_type.value)
	console.log('top_type.value------')

	init()
}
/**
 * 分页
 * sizeChange
 * currentChange
 * prevClick
 * nextClick
 * 
 */
const sizeChange = (val: number) => {
	init();
}
const currentChange = (val: number) => {
	page.value.pageNum = val;
	init();
}
const prevClick = (val: number) => {
	page.value.pageNum = val;
	init();
}
const nextClick = (val: number) => {
	page.value.pageNum = val;
	init();

}
</script>

<style scoped>
@import url(/src/assets/css/left_right.css);
@import url(/src/assets/css/com.css);

.newTrialMaterial {
	display: flex;
	margin: 0 auto;
}

.newTrialMaterial_box {
	width: 100%;
	display: flex;
	justify-content: space-between;
	padding: 0.2rem 0.17rem;
	box-sizing: border-box;
	vertical-align: middle;
	background-color: #F2F3F5;
}

.topBtn {
	font-size: 0.14rem;
	padding: 0.08rem 0.16rem;
	text-align: center;
	color: #333333;
	background: #FFFFFF;
	border-radius: 0.2rem;
	opacity: 1;
	border: 0.01rem solid #E5E6EB;
	margin-left: 0.2rem;
}

.table_img {
	background-color: #3FA4ED;
	width: 1rem;
	height: 0.8rem;
	background: #D9D9D9;
	border-radius: 0.08rem 0.08rem 0.08rem 0.08rem;
	opacity: 1;
	margin-right: 0.1rem;
}

.table_information {
	width: calc(100% - 1rem - 0.1rem);
	height: 0.8rem;
	display: flex;
	flex-direction: column;
	justify-content: center;
}

/deep/.el-tabs__nav-wrap::after {
	display: none;
}

/deep/ .el-table th.el-table__cell.is-leaf {
	background: #E3E6EC !important;
}

/deep/th .cell .el-checkbox__input {
	display: none;
}

/deep/.el-checkbox.el-checkbox--large {
	height: 0.2rem !important;
}

/deep/.is-active {
	color: #C01A26
}

/deep/.el-tabs__active-bar {
	display: none;
}

/deep/.el-tabs__nav {
	padding: 0 0.16rem;
}

/deep/.el-tabs__item:hover {
	color: #C01A26 !important;
}


/deep/.el-dialog.is-align-center {
	border-radius: 20px !important;
}

/deep/.rate .el-icon,
/deep/.rate .el-icon svg {
	height: 2em !important;
	width: 2em !important
}

/deep/.el-tabs__active-bar {
	display: none !important;
}

/deep/.el-tabs__item:hover {
	color: #C01A26;
}

/deep/.el-tabs__item.is-active {
	color: #C01A26;
}

/deep/.el-tabs__nav-scroll {
	padding-left: 0.12rem;
}

/deep/ .el-dropdown-link:focus {
	outline: none;
}

/* 分页 */

.el-pagination {
	justify-content: center;
}

/deep/.el-pager li {
	padding: 0.06rem;
	margin: 0 0.03rem;
}

/deep/.el-pager li.is-active {
	color: #FFF;
	background: #C01A26;

}

/deep/.el-pager li:hover {
	color: #FFF;
	background: #C01A26;
}

/deep/ .el-pagination.is-background .el-pager li.is-active {
	background: #C01A26;
}

/deep/.el-popper:focus {
	outline: none !important;
}
</style>
